import React from 'react';

const SprintsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default SprintsPage;
